export default function PHP_strrchr() {
  return (
    <div>
      <h1>PHP_strrchr</h1>
    </div>
  );
}
